import { render, staticRenderFns } from "./InsurerAutoItems.vue?vue&type=template&id=6c89c8ac"
import script from "./InsurerAutoItems.vue?vue&type=script&lang=js"
export * from "./InsurerAutoItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c89c8ac')) {
      api.createRecord('6c89c8ac', component.options)
    } else {
      api.reload('6c89c8ac', component.options)
    }
    module.hot.accept("./InsurerAutoItems.vue?vue&type=template&id=6c89c8ac", function () {
      api.rerender('6c89c8ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurer/InsurerAutoItems.vue"
export default component.exports